import React, { useState } from 'react';

import { NewButton, useToast } from '@eluve/components';

import { useGetFilePdfUrl } from './useGetFilePdfUrl';

export interface ViewAppointmentSuperbillButtonProps {
  tenantId: string;
  appointmentId: string;
}

export const ViewAppointmentSuperbillButton: React.FC<
  ViewAppointmentSuperbillButtonProps
> = ({ tenantId, appointmentId }) => {
  const toast = useToast();
  const handlePdf = useGetFilePdfUrl({
    appointmentId,
    tenantId,
    type: 'SUPERBILL',
  });

  const [isOpeningPdf, setIsOpeningPdf] = useState(false);

  const openPdf = async () => {
    const newTab = window.open('about:blank', '_blank');
    setIsOpeningPdf(true);
    const response = await handlePdf();
    if (response.status === 201 && newTab) {
      newTab.location = response.body.pdfUrl;
    } else {
      toast.error('Failed to prepare PDF');
    }
    setIsOpeningPdf(false);
  };

  return (
    <NewButton
      icon={{ name: 'FileText' }}
      loading={isOpeningPdf}
      onClick={openPdf}
      size="m"
      text="Superbill"
      type="subtle"
    />
  );
};
